import { faCoins } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import React, { useEffect, useState } from "react"
import { useAuth } from "../../contexts/auth"
import { verifyAccess } from "../../utils/admin.utils"
import AccessDenied from "../../components/access-denied/access-denied"

const PriceEnergy = () => {
    const {selectedDog} = useAuth()
    const [visiblePage, setVisiblePage] = useState(true)

    useEffect(() => {
        const pageRoles = [3,4]
        if (!verifyAccess(pageRoles, selectedDog)) {
            setVisiblePage(true)
            return
        }
        (async function(){
            setVisiblePage(true)
        })()
    },[selectedDog])

    return (
        <>{visiblePage ?
        <div className={'content-block dx-card responsive-paddings'}>
            <FontAwesomeIcon className="icon-header-h3 main-color main-color-light" icon={faCoins} />
            <h3><strong>Цена на электроэнергию текущего расчетного периода (under construction)</strong></h3>

        </div>
        : <AccessDenied/>}</>
    )
}

export default PriceEnergy
